import * as React from 'react'
import type { SVGProps } from 'react'
export interface LayoutSidebarLeftCollapseIconProps extends SVGProps<SVGSVGElement> {
  size?: number | string
}
/**
 * layout-sidebar-left-collapse
 * Tabler Icons
 * @url https://icon-sets.iconify.design/tabler
 * @license MIT
 */
export const LayoutSidebarLeftCollapseIcon = (
  props: LayoutSidebarLeftCollapseIconProps,
) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.size || '1em'}
      height={props.size || '1em'}
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm5-2v16" />
        <path d="m15 10l-2 2l2 2" />
      </g>
    </svg>
  )
}
